// extracted by mini-css-extract-plugin
module.exports = {"root":"mo-root-rBQNj","container":"mo-container-3DQxg","title":"mo-title-3QSu9","content":"mo-content-1Tbxr"};